export const faqsData = [
    {
        title: {
            en:'My business is not a restaurant, can I use the tools?',
            es: 'Si mi negocio no es un restaurante, ¿puedo usar las herramientas?'
        },
        description: {
            en: 'Of course, our tools are focused on restaurants, however they have functionalities that adapt to different types of businesses, whether small, medium or large.',
            es: '¡Por supuesto! Aunque nuestras herramientas están diseñadas pensando en los restaurantes, muchas de sus funciones se adaptan a negocios de distintos tamaños.'
        }
    },
    {
        title: {
            en:'What do I need to install the applications?',
            es: '¿Qué necesito para instalar las aplicaciones?'
        },
        description: {
            en: 'You simply need a modern internet-enabled device and follow our easy setup instructions. We keep it simple so you can focus on your restaurant.',
            es: 'Solo necesitas un dispositivo moderno con conexión a internet y seguir nuestras sencillas instrucciones de configuración. ¡Lo hemos hecho fácil para que te enfoques en tu restaurante!'
        },
    },
    {
        title: {
            en:'What if I require only one tool?',
            es: '¿Qué pasa si sólo necesito una de las herrmientas?'
        },
        description: {
            en: 'All our tools are built to work together seamlessly, but you are welcome to choose only what best fits your current needs.',
            es: 'Todas nuestras herramientas funcionan de forma integrada, pero puedes elegir únicamente la que mejor se adapte a tus necesidades actuales.'
        },
    },
    {
        title: {
            en:'Do I need advanced knowledge in technology to use them?',
            es: '¿Necesito tener conocimientos avanzados en aplicaciones para usar las herramientas?'
        },
        description: {
            en: 'Not at all! Our applications are designed to be intuitive and easy to use without requiring any specialized technical skills.',
            es: '¡Para nada! Nuestras aplicaciones están diseñadas para ser intuitivas y fáciles de usar, sin requerir conocimientos técnicos avanzados.'
        },
    },
    {
        title: {
            en:'How can I subscribe?',
            es: '¿Cómo me puedo subscribir?'
        },
        description: {
            en: 'You can subscribe through our website by selecting the best plan for your restaurant. The process is quick and straightforward.',
            es: 'Puedes suscribirte a través de nuestro sitio web, eligiendo el plan que mejor se adecúe a las necesidades de tu restaurante. Es un proceso rápido y sencillo.'
        },
    },
    {
        title: {
            en:'Do you offer technical support if I require it?',
            es: '¿Ofrecen soporte técnico en casa de lo necesite?'
        },
        description: {
            en: 'Yes, we offer technical support during business hours along with an online help center to assist you every step of the way.',
            es: 'Sí, ofrecemos soporte técnico durante el horario laboral y contamos con un centro de ayuda en línea para asistirte en todo momento.'
        },
    },
    {
        title: {
            en:'What kind of protection is offered to have safe access?',
            es: '¿Qué tipo de protección ofrecen para tener un acceso seguro?'
        },
        description: {
            en: 'Our applications use robust encryption and security protocols to safeguard your data, ensuring a safe and reliable access at all times.',
            es: 'Utilizamos protocolos de seguridad robustos y encriptación para proteger tus datos, garantizando un acceso seguro y confiable en todo momento.'
        },
    },
    {
        title: {
            en:'Is there some kind of guarantee of use?',
            es: '¿Hay algún tipo de garantía de uso?'
        },
        description: {
            en: 'As a startup currently not taking new clients, we offer a comprehensive demo environment where you can try out our full suite without any long-term commitment.',
            es: 'Si bien estamos en etapa inicial y actualmente no estamos tomando nuevos clientes, ofrecemos un entorno de demostración completo para que puedas probar nuestras herramientas sin compromiso a largo plazo.'
        },
    },
    {
        title: {
            en:'Does this have connection with POS?',
            es: '¿Tienen conexión con algún Punto de Venta?'
        },
        description: {
            en: 'Yes, our solutions integrate with several popular POS systems, making it easier to manage your restaurant operations efficiently.',
            es: 'Sí, nuestras soluciones se integran con varios sistemas de Punto de Venta populares, facilitando la gestión de las operaciones de tu restaurante.'
        },
    },
];